import { useCurrentSessionOrThrow } from '@/session/hooks/internal/useCurrentSessionOrThrow';

export const useCurrentWorkspace = () =>
  useCurrentSessionOrThrow().currentWorkspace;
